import React from "react";
import { useCachedPermissionContext } from "../hooks/useCachedPermissionContext";
import { useCachedMedium } from "../hooks/useCachedMedium";
import { useMediumStatusQuery } from "../hooks/useMediumStatusQuery";
import EventProfileBlocked from "../pages/EventProfileBlocked";
import PendingApprovalBlocked from "../pages/PendingApprovalBlocked";

interface EventTerreiroOnlyRouteProps {
  children: React.ReactNode;
}

const EventTerreiroOnlyRoute: React.FC<EventTerreiroOnlyRouteProps> = ({
  children,
}) => {
  const { isPersonalProfile, terreiroId } = useCachedPermissionContext();
  const cachedMedium = useCachedMedium();
  const mediumId = cachedMedium?.id;

  const { data: mediumStatusData } = useMediumStatusQuery({
    mediumId,
    enabled: !!terreiroId && !!mediumId,
  });

  const mediumStatus =
    typeof mediumStatusData === "object" &&
    mediumStatusData !== null &&
    "status" in mediumStatusData
      ? String(
          (mediumStatusData as { status?: unknown }).status ?? "",
        ).toUpperCase()
      : "";

  if (isPersonalProfile || !terreiroId) {
    return <EventProfileBlocked />;
  }

  if (mediumStatus === "WAITING_APPROVAL") {
    return <PendingApprovalBlocked />;
  }

  return <>{children}</>;
};

export default EventTerreiroOnlyRoute;
